module.exports = __webpack_public_path__ + "img/zip.12160311.png";